import React from "react";
import { money } from "@/lib/financeApi";

const PLAIN = new Set(["count", "rows", "days_outstanding"]);
const fmt = (k, v) => (v == null || v === "" ? "—" : typeof v === "number" && !PLAIN.has(k) ? money(v) : String(v).replace(/_/g, " "));
const TONE = { red: "bg-red-500/10 text-red-200", muted: "text-nex-muted/70" };

/** Generic read-only report table: {columns, rows (with optional _subtotal/_tone), totals}. */
export default function ReportTable({ report, testid }) {
  const { columns, rows, totals } = report;
  return (
    <div className="border border-white/10 rounded-sm overflow-x-auto">
      <table data-testid={testid} className="w-full text-left text-sm">
        <thead><tr className="font-mono text-[9px] tracking-[0.16em] uppercase text-nex-muted">
          {columns.map((c) => <th key={c.key} className="px-3 py-2 font-normal whitespace-nowrap">{c.label}</th>)}
        </tr></thead>
        <tbody>
          {rows.map((r, i) => (
            <tr key={i} data-testid={`${testid}-row-${i}`} className={`border-t border-white/5 ${r._subtotal ? "bg-white/[0.03] font-semibold" : ""} ${TONE[r._tone] || ""}`}>
              {columns.map((c) => <td key={c.key} className={`px-3 py-1.5 whitespace-nowrap ${typeof r[c.key] === "number" ? "font-mono text-xs" : "text-xs"} ${r._subtotal ? "text-nex-gold" : r._tone ? "" : "text-nex-silver"}`}>{r._subtotal && r[c.key] == null ? "" : fmt(c.key, r[c.key])}</td>)}
            </tr>
          ))}
          {totals && Object.keys(totals).length > 0 && (
            <tr data-testid={`${testid}-totals`} className="border-t border-nex-gold/30 font-mono text-xs">
              {columns.map((c, i) => <td key={c.key} className="px-3 py-2 text-nex-gold whitespace-nowrap">{i === 0 ? "TOTAL" : totals[c.key] != null ? fmt(c.key, totals[c.key]) : ""}</td>)}
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
}
